import {Directive, ElementRef, HostBinding} from "@angular/core";

@Directive({
  selector: '[vbAddButton]'
})
export class AddButtonDirective {

  constructor(el: ElementRef) {
    el.nativeElement.appendChild("TTT");
  }

  @HostBinding('class')
  buttonClass = "btn btn-default btn-sm";

}



// WEBPACK FOOTER //
// ./src/app/core/visbos-core/ui/buttons/add-button.directive.ts